import { SmopOrderStatusEnum } from "@saleor/types/globalTypes";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";

const orderSectionUrl = "/mother-orders";
export const orderListPath = orderSectionUrl;

const masterFulfillmentSectionUrl = "/master-fulfillment";
export const masterFulfillmentListPath = masterFulfillmentSectionUrl;

export enum OrderListUrlFiltersEnum {
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  customer = "customer",
  payment = "payment",
  query = "query",
  status = "status",
  shippingFrom = "shippingFrom",
  shippingTo = "shippingTo",
  store = "store",
  riderFirstName = "riderFirstName",
  riderLastName = "riderLastName"
}
export enum OrderListUrlFiltersWithMultipleValuesEnum {
  deliveryType = "deliveryType",
  verticalType = "verticalType",
  orderCourier = "orderCourier",
  mall = "mall"
}
export type OrderListUrlFilters = Filters<OrderListUrlFiltersEnum> &
  FiltersWithMultipleValues<OrderListUrlFiltersWithMultipleValuesEnum>;
export type OrderListUrlDialog =
  | "cancel"
  | TabActionDialog
  | "onClickGenerateShippingLabel"
  | "onClickAssignRider"
  | "onClickAddRemarks"
  | "onOverrideStatus"
  | "onClickSaveButton"
  | "confirmGrabOverride"
  | "onGrabOverrideStatus"
  | "download";
export enum OrderListUrlSortField {
  number = "number",
  customer = "customer",
  date = "date",
  fulfillment = "status",
  payment = "payment",
  total = "total"
}
export type OrderListUrlSort = Sort<OrderListUrlSortField>;
export type OrderListUrlQueryParams = BulkAction &
  Dialog<OrderListUrlDialog> &
  OrderListUrlFilters &
  OrderListUrlSort &
  Pagination &
  ActiveTab & {
    orderId?: string;
    orderCode?: string;
    mallId?: string;
    orderStatus?: SmopOrderStatusEnum;
    newOrderStatus?: SmopOrderStatusEnum;
    courier?: string;
    orderOldRemarks?: string;
    orderOldRemarkId?: string;
    isFromNotification?: string;
  };

export const orderListUrl = (params?: OrderListUrlQueryParams): string => {
  const orderList = orderListPath;
  if (params === undefined) {
    return orderList;
  } else {
    return urlJoin(orderList, "?" + stringifyQs(params));
  }
};
export const masterFulfillmentListUrl = (
  params?: OrderListUrlQueryParams
): string => {
  const url = masterFulfillmentListPath;
  if (params === undefined) {
    return url;
  } else {
    return urlJoin(url, "?" + stringifyQs(params));
  }
};

export const orderDraftListPath = urlJoin(orderSectionUrl, "drafts");
export enum OrderDraftListUrlFiltersEnum {
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  customer = "customer",
  query = "query"
}
export type OrderDraftListUrlFilters = Filters<OrderDraftListUrlFiltersEnum>;
export type OrderDraftListUrlDialog = "remove" | TabActionDialog;
export enum OrderDraftListUrlSortField {
  number = "number",
  customer = "customer",
  date = "date",
  total = "total"
}
export type OrderDraftListUrlSort = Sort<OrderDraftListUrlSortField>;
export type OrderDraftListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<OrderDraftListUrlDialog> &
  OrderDraftListUrlFilters &
  OrderDraftListUrlSort &
  Pagination;
export const orderDraftListUrl = (
  params?: OrderDraftListUrlQueryParams
): string => {
  const orderDraftList = orderDraftListPath;
  if (params === undefined) {
    return orderDraftList;
  } else {
    return urlJoin(orderDraftList, "?" + stringifyQs(params));
  }
};

export const orderPath = (id: string) => urlJoin(orderSectionUrl, id);
export const masterFulfillmentPath = (id: string) =>
  urlJoin(masterFulfillmentSectionUrl, id);

export type OrderUrlDialog =
  | "add-order-line"
  | "cancel"
  | "cancel-fulfillment"
  | "capture"
  | "edit-billing-address"
  | "edit-fulfillment"
  | "edit-shipping"
  | "edit-shipping-address"
  | "finalize"
  | "mark-paid"
  | "refund"
  | "void"
  | "invoice-send"
  | "onClickAssignRider"
  | "onClickAddRemarks"
  | "onClickOrderProduct"
  | "onClickSaveButton"
  | "onClickShipped"
  | "onClickCompleted"
  | "onClickGenerateShippingLabel"
  | "onOverrideStatus"
  | "onGrabOverrideStatus"
  | "onAssignHomeLocation";
export interface OrderProductDialog {
  motherOrderStatus?: SmopOrderStatusEnum;
  orderId?: string;
  productId?: { variantId: any; storeOrderId: any };
}

export type OrderUrlQueryParams = Dialog<OrderUrlDialog> &
  SingleAction &
  OrderProductDialog & {
    mall?: string;
  };

export const orderUrl = (id: string, params?: OrderUrlQueryParams) =>
  orderPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
export const masterFulfillmentUrl = (
  id: string,
  params?: OrderUrlQueryParams
) => masterFulfillmentPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const orderFulfillPath = (id: string) =>
  urlJoin(orderPath(id), "fulfill");
export const orderFulfillUrl = (id: string) =>
  orderFulfillPath(encodeURIComponent(id));
